import { Compra } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';


export enum CompraRetencionKey {
    compraRetencion = 'compraRetencion',
}
const setAlert = useUiStore.getState().setAlert;

export interface DynamicTableStore {
  compraRetencion: any[];

  clearCompraRetencion: () => void;
  //
  removeCompraRetencion: (id: string, key: CompraRetencionKey) => void;
  addRetencionComprasPago: (items: Compra, key: CompraRetencionKey) => void;

}

const idsAreEqual = (id1: string | number, id2: string | number) => {
  if (typeof id1 === 'number' && typeof id2 === 'number' && isFinite(id1) && isFinite(id2)) {
    return id1 === id2;
  }
  if (typeof id1 === 'string' && typeof id2 === 'string') {
    return id1 === id2;
  }
  return false;
}
export const useCompraRetencionUtilizadosStore = create<DynamicTableStore>()(
  persist(
    (set,get) => ({
      //formas pago
      compraRetencion: [],

      clearCompraRetencion: () => {
        set({ compraRetencion: [] });
      },
      addRetencionComprasPago: (item, key) => {
        const itemExists = get()[key].some(
          i => JSON.stringify(i) === JSON.stringify(item)
        );
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));
          setAlert(true, 'Compra agregada correctamente', 'success');
        } else {
          setAlert(true, 'Ya se encuentra agregado esta compra', 'warning');
        }
      },
      removeCompraRetencion: (id, key) => {
        set(state => ({
          ...state,
          [key]: state[key].filter(item => !idsAreEqual(item.id_retencion, id)),
        }));
      },
    }),
    { name: 'CompraRetencion-utilizados-store' }
  )
);
